module.exports = __webpack_public_path__ + "img/troll_hut_small.6f9ed294.png";